import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';

const TableSkeleton = ({ rows = 5 }) => {
  // Define custom skeleton colors
  const baseColor = '#E7EAFF'; // Darker base color
  const highlightColor = '#dce1fc'; // Slightly lighter highlight

  return (
    <FlexboxColumn className='table_container' gap='0'>
      {/* Header Skeleton */}
      <Flexbox className='table_container__header' fw>
        <div className='name'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </div>
        <Flexbox className='contribution' justifyContent='flex-start' gap='0.5rem'>
          <Skeleton width={120} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>
        <Flexbox className='rank' justifyContent='flex-start' gap='0.5rem'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>

        <Flexbox className='rank' justifyContent='flex-start' gap='0.5rem'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>
        <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>
        <div className='action'>
          <Skeleton width={20} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </div>
      </Flexbox>

      {/* Row Skeletons */}
      {Array.from({ length: rows }).map((_, index) => (
        <Flexbox className='table_container__row' fw key={index}>
          <Flexbox className='name' gap='0.5rem' justifyContent='flex-start'>
            <Skeleton circle width={20} height={20} baseColor={baseColor} highlightColor={highlightColor} />
            <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </Flexbox>
          <div className='contribution'>
            <Skeleton width={80} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </div>
          <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
            <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </Flexbox>
          <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
            <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </Flexbox>
          <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
            <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </Flexbox>
          <div className='action'>
            <Skeleton width={20} height={20} baseColor={baseColor} highlightColor={highlightColor} />
          </div>
        </Flexbox>
      ))}
    </FlexboxColumn>
  );
};

export default TableSkeleton;
